var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function transformValueToCSSVar(value) {
    return "var(--" + value.id + ", " + (typeof value.value === 'object' ? transformValueToCSSVar(value.value) : value.value) + ")";
}
export function designToken(id, value) {
    var lowerCaseId = id.replace(/([A-Z])/g, '-$1').toLowerCase();
    var specValue = {
        id: lowerCaseId,
        value: value
    };
    var cssVar = '';
    return __assign(__assign({}, specValue), { var: function () {
            if (!cssVar) {
                cssVar = transformValueToCSSVar(specValue);
            }
            return cssVar;
        },
        getStringValue: function (element) {
            return getComputedStyle(element || document.documentElement).getPropertyValue("--" + lowerCaseId);
        },
        getIntValue: function (element) {
            return parseInt(getComputedStyle(element || document.documentElement).getPropertyValue("--" + lowerCaseId), 10);
        } });
}
export function createTokens(prefix, decl) {
    return Object.entries(decl).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        var id = key.replace(/([A-Z])/g, '-$1').toLowerCase();
        acc[key] = {
            id: prefix ? prefix + "-" + id : id,
            value: value
        };
        return acc;
    }, {});
}
export function createCSSValues(spec) {
    return Object.entries(spec).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        acc[key] = transformValueToCSSVar(value);
        return acc;
    }, {});
}
export function defineCSSVars(spec) {
    var items = [];
    var parse = function (value) {
        if (typeof value.value === 'object') {
            parse(value.value);
        }
        items.push("--" + value.id + ": " + (typeof value.value !== 'object' ? value.value : "var(--" + value.value.id + ")") + ";");
    };
    Object.values(spec).forEach(parse);
    return items.join('\n');
}
//# sourceMappingURL=utils.js.map